export const Projects = [
  {
    key: "Pretend",
    title: "Pretend",
    role: "Set Design, Props",
    billing: (
      <>
        By Tom Simmons
        <br />
        <br />
        artxnyc| 2026
        <br />
        Director: Emily Lincoff
        <br />
        <br />
        Produced: Manufactured Illusions
        <br />
        Movement Direction: Allie Beltran
        <br />
        Lighting Design: Henry Mont
        <br />
        Sound: Emi Verhar
        <br />
        Photos: Geve Penn
      </>
    ),
    images: [
      "/Assets/pretend1.jpeg",
      "/Assets/pretend2.jpeg",
      "/Assets/pretend3.jpeg",
      "/Assets/pretend4.jpeg",
      "/Assets/pretend5.jpeg",
      "/Assets/pretend6.jpeg",
    ],
    route: "pretend",
  },
  {
    key: "Ghostly",
    title: "Ghostly Little Play",
    role: "Director",
    billing: (
      <>
        By Zach Susini
        <br />
        <br />
        Desotelle Studios| 2026
        <br />
        <br />
        Produced: Juliana Morgado Brito, Zach Susini, Isaac Jenemann
        <br />
        Stage Manager: Will Havens 
        <br />
        Photos: Jake Srebnick 
      </>
    ),
    images: [
      "/Assets/ghostly1.jpeg",
      "/Assets/ghostly2.jpeg",
      "/Assets/ghostly3.jpeg",
      "/Assets/ghostly4.jpeg",
      "/Assets/ghostly5.jpeg",
      "/Assets/ghostly6.jpeg",
    ],
    route: "ghostly",
  },
  {
    key: "Sheets",
    title: "Sheets",
    role: "Set Design",
    billing: (
      <>
        By Nic Evans
        <br />
        <br />
        The Craftsman| 2025
        <br />
        Director: Kylie Marco & Nic Evans
        <br />
        <br />
        Produced: Kylie Marco & Nic Evans
        <br />
        Stage Manager: Gabby Cadden
        <br />
        Costuming: Kylie Marco
        <br />
        Intimacy: Gabrielle Hagenlocker
        <br />
        Photos: Gabrielle Hagenlocker
      </>
    ),
    images: [
      "/Assets/sheets5.jpeg",
      "/Assets/sheets4.jpeg",
      "/Assets/sheets1.jpeg",
      "/Assets/sheets3.jpeg",
      "/Assets/sheets2.jpeg"
    ],
    route: "sheets",
  },
  {
    key: "Fyre",
    title: "Fyre Fest Was So Fun!!!",
    role: "Set Design",
    billing: (
      <>
        By Catherine Weingarten
        <br />
        <br />
        The Bench | 2025
        <br />
        Director: Meg Maccarey
        <br />
        <br />
        Produced: GirlPox
        <br />
        Lighting: Henry Mont
        <br />
        Sound: Julia Little
        <br />
        Photos: Geve Penn
      </>
    ),
    images: [
      "/Assets/fyre1.jpeg",
      "/Assets/fyre2.jpeg",
      "/Assets/fyre3.jpeg",
      "/Assets/fyre4.jpeg",
      "/Assets/fyre5.jpeg",
    ],
    route: "fyrefestwassofun",
  },
  {
    key: "Rocks",
    title: "Rocks and Geodes",
    role: "Set Design",
    billing: (
      <>
        By Lydia Reiss
        <br />
        <br />
        Brooklyn Center for Theater Research | 2025
        <br />
        Director: Kaitlin Goldin
        <br />
        <br />
        Produced: Lou Baron
        <br />
        Associate Director: Lydia Sims
        <br />
        Lighting: Henry Mont
        <br />
        Costumes: Josie Miller
        <br />
        Sound: Julia Little
        <br />
        Photos: Inès Valencia
      </>
    ),
    images: [
      "/Assets/rocks4.jpeg",
      "/Assets/rocks5.jpeg",
      "/Assets/rocks2.jpeg",
      "/Assets/rocks3.jpeg",
      "/Assets/rocks6.jpeg",
      "/Assets/rocks1.jpeg",
    ],
    route: "rocksandgeodes",
  },
  {
    key: "Moors",
    title: "The Moors",
    role: "Set Design",
    billing: (
      <>
        By Jen Silverman
        <br />
        <br />
        Uptown One Train | 2025
        <br />
        Director: Josie Miller
        <br />
        <br />
        Lighting: Lizi Zhang
        <br />
        Technical Direction: Sam Giamatti
        <br />
        Costumes: Dayna Nolan
        <br />
        Sound: Kaitlin Goldin
        <br />
        Photos: Avery Yuan and Ethan Homen
      </>
    ),
    images: [
      "/Assets/moors4.jpeg",
      "/Assets/moors2.jpeg",
      "/Assets/moors1.jpeg",
      "/Assets/moors6.jpeg",
      "/Assets/moors5.jpeg",
      "/Assets/moors3.jpeg",
    ],
    route: "themoors",
  },

  {
    key: "Buzzkill",
    title: "Buzzkill",
    role: "Artistic Director",
    billing: (
      <>
        By Zoe Redlich & Celine Dipp
        <br />
        <br />
        Independent | 2024
        <br />
        Director: Zoe Redlich & Celine Dipp
        <br />
        <br />
        Produced: Dorrit Corwin, Brayson Freeman, Luke Riley
        <br />
        Director of Photography: Nat Mitchell & Isaac McKenna
        <br />
        Assistant Director: Grace Belgrader
        <br />
        Production Design: Juliana Morgado Brito
        <br />
        Costumes: Lucinda Drake
      </>
    ),
    images: [
      "/Assets/Buzzkill.jpeg",
      "/Assets/Buzzkill1.jpeg",
      "/Assets/Buzzkill2.jpeg",
      "/Assets/Buzzkill3.jpeg",
      "/Assets/Buzzkill4.jpeg",
      "/Assets/Buzzkill5.jpeg",
    ],
    route: "buzzkill",
  },

  {
    key: "Midsummer",
    title: (
      <>
        A Midsummer <br />
        Night's Dream
      </>
    ),
    role: "Set Design",
    billing: (
      <>
        By William Shakespeare
        <br />
        <br />
        The Downspace | 2024
        <br />
        Director: Fiona Mathews & Liliana Greyf
        <br />
        <br />
        Produced: Production Workshop
        <br />
        Lighting: Milan Capoor
        <br />
        Technical Direction: Sofia Tazi & Keelin Gaughan
        <br />
        Sound: Juliana Morgado Brito
      </>
    ),
    images: [
      "/Assets/Midsummer2.jpeg",
      "/Assets/Midsummer1.jpeg",
      "/Assets/Midsummer3.jpeg",
      "/Assets/Midsummer6.jpeg",
      "/Assets/Midsummer4.jpeg",
      "/Assets/Midsummer5.jpeg",
    ],
    route: "midsummer",
  },

  {
    key: "Sic",
    title: "[sic]",
    role: "Set Design",
    billing: (
      <>
        By Melissa James Gibson
        <br />
        <br />
        Fishman Studio | 2024
        <br />
        Director: Daniel Quinter
        <br />
        <br />
        Produced: Something on the Green
        <br />
        Lighting: Lizi Zhang
        <br />
        Costumes: Wenhao Cai
        <br />
        Sound: Juliana Morgado Brito
      </>
    ),
    images: [
      "/Assets/sic2.jpeg",
      "/Assets/sic3.jpeg",
      "/Assets/sic6.jpeg",
      "/Assets/sic4.jpeg",
      "/Assets/sic1.jpeg",
      "/Assets/sic5.jpeg",
    ],
    route: "sic",
  },

  {
    key: "Psycho",
    title: "Psychosychotic",
    role: "Set Design",
    billing: (
      <>
        By Alexa Derman
        <br />
        <br />
        The Downspace | 2023
        <br />
        Directed: Josephine Miller
        <br />
        <br />
        Produced: Production Workshop
        <br />
        Lighting Design: Lizi Zhang
        <br />
        Technical Direction: Sam Giamatti
        <br />
        Sound: Juliana Morgado Brito
      </>
    ),
    images: [
      "/Assets/psycho1.jpeg",
      "/Assets/psycho5.jpeg",
      "/Assets/psycho2.jpeg",
      "/Assets/psycho9.jpeg",
      "/Assets/psycho4.jpeg",
      "/Assets/psycho6.jpeg",
    ],
    route: "psychopsychotic",
  },

  {
    key: "IntoTheWoods",
    title: "Into the Woods",
    role: "Technical Direction",
    billing: (
      <>
        Music and Lyrics by Stephen Sondheim
        <br />
        Book by James Lapine
        <br />
        <br />
        Fishman Studio | 2023
        <br />
        Director: Ethan Mullen & Elise Aronson
        <br />
        <br />
        Produced: Brown Univerity
        <br />
        Set Design: Juliana Morgado-Brito
        <br />
        Lighting Design: Lizi Zhang
        <br />
        Costumes: Lulu Cavicchi
        <br /> Sound: Milan Capoor
      </>
    ),
    images: [
      "/Assets/woods5.jpeg",
      "/Assets/woods2.jpeg",
      "/Assets/woods3.jpeg",
      "/Assets/woods4.jpeg",
      "/Assets/woods1.jpeg",
      "/Assets/woods6.jpeg",
    ],
    route: "intothewoods",
  },

  {
    key: "Stupid",
    title: "Stupid Fucking Bird",
    role: "Set Design",
    billing: (
      <>
        By Aaron Posner
        <br />
        <br />
        The Downspace | 2022
        <br />
        Directed: Maddie Groff
        <br />
        <br />
        Produced: Something on the Green
        <br />
        Lighting: Yana Tsyvis
        <br />
        Costumes: Ines Sawiris and Alden Forbes
        <br />
        Sound: Juliana Morgado Brito
      </>
    ),
    images: [
      "/Assets/stupid5.jpeg",
      "/Assets/stupid6.jpeg",
      "/Assets/stupid3.jpeg",
      "/Assets/stupid1.jpeg",
      "/Assets/stupid4.jpeg",
      "/Assets/stupid2.jpeg",
    ],
    route: "stupidfkngbird",
  },
];






